// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDUl5EgoSI_GM7IkYn-QjbXkv4fGn1vSm0",
  authDomain: "transito-ai-test-01-e7c98.firebaseapp.com",
  projectId: "transito-ai-test-01",
  storageBucket: "transito-ai-test-01.appspot.com",
  messagingSenderId: "709891597787",
  appId: "1:709891597787:web:227307a080b26e321f33fe",
  measurementId: "G-WC28DD29HQ",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { app, db };
